module.exports = __webpack_public_path__ + "img/Whakapapa.2e960b6d.png";